// extracted by mini-css-extract-plugin
export default {"BoxContainer":"BoxContainer_BoxContainer__JV1p2"};